export enum Cinsiyet {
    erkek = "erkek",
    kadin = "kadin"
}

export enum CinsiyetLabel {
    erkek = "Erkek",
    kadin = "Kadın"
}
